/** Smooth monotone cubic through the points (Fritsch-Carlson): rounded like Shopify's lines, and it never overshoots a real
 *  value, so the curve never dips below or rises above what actually happened. */
export function smoothPath(p: [number, number][]): string {
  const n = p.length
  if (n === 0) return ''
  if (n === 1) return `M${p[0][0]},${p[0][1]}`
  const dx: number[] = [], m: number[] = [], t: number[] = []
  for (let i = 0; i < n - 1; i++) { dx[i] = p[i + 1][0] - p[i][0]; m[i] = (p[i + 1][1] - p[i][1]) / (dx[i] || 1) }
  t[0] = m[0]; t[n - 1] = m[n - 2]
  for (let i = 1; i < n - 1; i++) {
    if (m[i - 1] * m[i] <= 0) t[i] = 0
    else { const a = 2 * dx[i] + dx[i - 1], b = dx[i] + 2 * dx[i - 1]; t[i] = (a + b) / (a / m[i - 1] + b / m[i]) }
  }
  let d = `M${p[0][0].toFixed(1)},${p[0][1].toFixed(1)}`
  for (let i = 0; i < n - 1; i++) {
    const h = dx[i] / 3
    d += `C${(p[i][0] + h).toFixed(1)},${(p[i][1] + h * t[i]).toFixed(1)} ${(p[i + 1][0] - h).toFixed(1)},${(p[i + 1][1] - h * t[i + 1]).toFixed(1)} ${p[i + 1][0].toFixed(1)},${p[i + 1][1].toFixed(1)}`
  }
  return d
}
